import { updateBodyClass } from "./updateBodyClass";
export var FONT_CLASSES = [
    "font-size--normal",
    "font-size--medium",
    "font-size--large",
    "font-size--x-large"
];
export var CONTRAST_CLASSES = [
    "contrast--normal",
    "contrast--blackwhite",
    "contrast--whiteblack",
    "contrast--yellowblue",
    "contrast--blueyellow",
    "contrast--redcyan",
    "contrast--greenblack"
];
export var LETTER_SPACING_CLASSES = [
    "letter-spacing--normal",
    "letter-spacing--medium",
    "letter-spacing--large",
    "letter-spacing--x-large"
];
export var WORD_SPACING_CLASSES = [
    "word-spacing--normal",
    "word-spacing--medium",
    "word-spacing--large",
    "word-spacing--x-large"
];
export var LINE_SPACING_CLASSES = [
    "line-spacing--normal",
    "line-spacing--medium",
    "line-spacing--large",
    "line-spacing--x-large"
];
export var BG_HIDDEN_CLASS = "bg--hidden";
export var ANIMATION_HIDDEN_CLASS = "animation--hidden";
var FONT_SIZE_KEY = "cbook-font-size";
var CONTRAST_KEY = "cbook-contrast";
var BG_KEY = "cbook-bg";
var ANIMATION_KEY = "cbook-animation";
var LETTER_SPACING_KEY = "cbook-letter-spacing";
var WORD_SPACING_KEY = "cbook-word-spacing";
var LINE_SPACING_KEY = "cbook-line-spacing";
export var getFontSize = function() {
    return localStorage.getItem(FONT_SIZE_KEY) || FONT_CLASSES[0];
};
export var getLetterSpacing = function() {
    return localStorage.getItem(LETTER_SPACING_KEY) || LETTER_SPACING_CLASSES[0];
};
export var getWordSpacing = function() {
    return localStorage.getItem(WORD_SPACING_KEY) || WORD_SPACING_CLASSES[0];
};
export var getLineSpacing = function() {
    return localStorage.getItem(LINE_SPACING_KEY) || LINE_SPACING_CLASSES[0];
};
export var getContrast = function() {
    return localStorage.getItem(CONTRAST_KEY) || CONTRAST_CLASSES[0];
};
export var getBackgroundOption = function() {
    return localStorage.getItem(BG_KEY);
};
export var getAnimationOption = function() {
    return localStorage.getItem(ANIMATION_KEY);
};
export var updateFontSize = function(newClass) {
    var currClass = getFontSize();
    updateBodyClass(currClass, newClass);
    localStorage.setItem(FONT_SIZE_KEY, newClass);
};
export var updateContrast = function(newClass) {
    var currClass = getContrast();
    updateBodyClass(currClass, newClass);
    localStorage.setItem(CONTRAST_KEY, newClass);
};
export var updateBackgroundOption = function(newClass) {
    var currClass = getBackgroundOption();
    updateBodyClass(currClass, newClass || "");
    if (newClass) {
        localStorage.setItem(BG_KEY, newClass);
    } else {
        localStorage.removeItem(BG_KEY);
    }
};
export var updateAnimationOption = function(newClass) {
    var currClass = getAnimationOption();
    updateBodyClass(currClass, newClass || "");
    if (newClass) {
        localStorage.setItem(ANIMATION_KEY, newClass);
    } else {
        localStorage.removeItem(ANIMATION_KEY);
    }
};
export var updateLetterSpacing = function(newClass) {
    var currClass = getLetterSpacing();
    updateBodyClass(currClass, newClass);
    localStorage.setItem(LETTER_SPACING_KEY, newClass);
};
export var updateWordSpacing = function(newClass) {
    var currClass = getWordSpacing();
    updateBodyClass(currClass, newClass);
    localStorage.setItem(WORD_SPACING_KEY, newClass);
};
export var updateLineSpacing = function(newClass) {
    var currClass = getLineSpacing();
    updateBodyClass(currClass, newClass);
    localStorage.setItem(LINE_SPACING_KEY, newClass);
};
